import React from 'react';
import {Breadcrumb, Input} from 'antd';
import styles from './index.module.less';
import history from '../libs/history';
import homePic from './home.png'
// the hook
import {useTranslation} from 'react-i18next';

const {Search} = Input;
export default function (props) {
  const {t} = useTranslation();// {t('')}

  // let showBread = ['/', '/home','/goods'].indexOf(this.props.crumb.path) !==-1
  let showSearchFrom = ['/goods/detail'].indexOf(props.crumb.path) !== -1
  let isUserCenter = (props.crumb.path).indexOf('/user') !== -1

  return (
    <div className={styles.crumbSection} hidden={props.showBrand}>
      <div className={styles.breadcrumb}>
        <Breadcrumb className={styles.resetCrumb} separator="&gt;">
          {
            !isUserCenter ? (
              <Breadcrumb.Item onClick={() => {
                history.push('/home')
              }}>
                <span style={{cursor: "pointer"}}><img src={homePic} alt=""/> {t('网站首页')}</span>
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item onClick={() => {
                history.push('/user/purchase')
              }}>
                <span style={{cursor: "pointer"}}><img src={homePic} alt=""/> {t('用户中心')}</span>
              </Breadcrumb.Item>
            )
          }
          {
            props.crumb.pTitle ? (
              <Breadcrumb.Item onClick={() => {
                history.push(props.crumb.href)
              }}>
                <span style={{cursor: props.crumb.href ? "pointer" : ""}}>{t(props.crumb.pTitle)}</span>
              </Breadcrumb.Item>
            ) : null
          }
          <Breadcrumb.Item>
            <span>{t(props.crumb.title)}</span>
          </Breadcrumb.Item>
        </Breadcrumb>


        {/* <div className={styles.search} hidden={!showSearchFrom}>
          <Search placeholder={t('请输入产品名称、货号')}
                  bordered={false}
                  onSearch={() => {
                  }}/>
        </div> */}
      </div>
    </div>
  )
}
